import Vue from "vue";

export default Vue.extend({
    computed: {
        themeStorageState(): string | null {
            return localStorage.getItem("darkTheme");
        },
        systemDarkSettings(): boolean {
            return (
                window.matchMedia &&
                window.matchMedia("(prefers-color-scheme: dark)").matches
            );
        },
    },
    mounted() {
        const theme = this.themeStorageState;
        if (theme !== null) {
            if (theme === "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        } else if (this.systemDarkSettings) {
            this.setTheme(true);
        }
    },
    methods: {
        toggleTheme(): void {
            this.setTheme(!this.$vuetify.theme.dark);
        },
        setTheme(theme: boolean): void {
            this.$vuetify.theme.dark = theme;
            localStorage.setItem("darkTheme", theme.toString());
        },
    },
});
